<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <el-form-item label="">
        <el-input v-model="filters.name" placeholder="医院名称"></el-input>
      </el-form-item>
      <!-- <el-form-item label="">
        <el-input v-model="filters.bwacctnumber" placeholder="医院编码"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="">
         <el-select v-model="filters.CheckStatus" clearable placeholder="验证状态">
              <el-option label="待验证" :value="1"></el-option>
              <el-option label="验证中" :value="2"></el-option>
              <el-option label="验证通过" :value="3"></el-option>
              <el-option label="未通过" :value="-1"></el-option>
            </el-select>
      </el-form-item> -->
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          v-if="!item.IsHide"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div">
      <div>
        <el-table
          v-if="!isMobile"
          border
          :max-height="tableHeight"
          :data="users"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA' }"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
        >
          <!-- <el-table-column sortable type="selection" width="50">
      </el-table-column>-->
          <el-table-column type="index" width="80">
            <template slot="header" slot-scope="{}">
              <span style="padding: 8px 0">
                序号
                <span class="caret-wrapper" style="width: 0px"></span>
              </span>
              <!-- <span class="caret-wrapper" style="padding-top: 0px"></span> -->
            </template>
          </el-table-column>
          <!-- <el-table-column sortable prop="BWAcctNumber" label="ZCN ID" width="160"></el-table-column> -->
          <el-table-column sortable prop="Name" label="医院名称" min-width="220"></el-table-column>
          <el-table-column sortable prop="original_name" label="医院曾用名" min-width="220"></el-table-column>
          <!-- <el-table-column sortable prop="invoice_name" label="发票名称" width="220"></el-table-column> -->
          <!-- <el-table-column sortable prop="Address" label="医院地址" min-width="220"></el-table-column> -->
          <el-table-column sortable prop="province_name" label="省份" min-width=""></el-table-column>
          <!-- <el-table-column sortable prop="cityid" label="城市" width=""></el-table-column> -->
          <el-table-column prop="city_name" label="城市" min-width="100">
            <template slot="header" slot-scope="{}">
              <span style="padding: 0px 0; height: 34px; display: inline-block; line-height: 32px">
                城市
                <i @click="cp_zk_click" style="cursor: pointer" :class="HCO_LIST_IF ? 'el-icon-remove' : 'el-icon-circle-plus'"></i>
              </span>
              <!-- <span class="caret-wrapper" style="padding-top: 0px"></span> -->
            </template>
          </el-table-column>
          <!-- <div v-if="HCO_LIST_IF"> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="is_private" label="公私立" width="120">
            <template scope="scope">{{ scope.row.is_private ? '私立' : '公立' }}</template>
          </el-table-column> -->
          <el-table-column v-if="HCO_LIST_IF" sortable prop="sales_region_large_name" label="大区" width=""></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="sales_region_small_name" label="小区" width=""></el-table-column>
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="Category" label="类型" width=""></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="level" label="级别" width=""></el-table-column> -->
          <el-table-column v-if="HCO_LIST_IF" sortable prop="crystal_position_code" label="晶体销售岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="crystal_position_code_name" label="晶体销售" width="120"></el-table-column>
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="facility_position_code" label="CD临床应用发展岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="facility_position_code_name" label="设备销售" width="120"></el-table-column> -->
          <el-table-column v-if="HCO_LIST_IF" sortable prop="ref_crystal_position_code" label="REF销售岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="ref_crystal_position_code_name" label="REF销售" width="120"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="cat_crystal_position_code" label="飞白设备销售岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="cat_crystal_position_code_name" label="Cat销售" width="120"></el-table-column>
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="pd_position_code" label="PPD先进术式发展岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="pd_position_code_name" label="PPD销售" width="120"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="cat_Group" label="白内障私立医院集团" width="200"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="ref_Group" label="屈光飞白私立医院集团" width="200"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="IsContainsEyes" label="执业范围是否包含眼科相关" width="220"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="license_life" label="执业许可有效期" width="150"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="business_life" label="营业许可有效期" width="150"></el-table-column> -->
          <!-- </div> -->
          <el-table-column label="操作" width="160">
            <template slot="header" slot-scope="{}">
              <span style="padding: 8px 0">
                操作
                <span class="caret-wrapper" style="width: 0px"></span>
              </span>
            </template>
            <template scope="scope">
              <el-link type="primary" @click="handledetails(scope.row)">
                <i class="el-icon-edit-outline"></i>
                审批
              </el-link>
            </template>
          </el-table-column>
        </el-table>

        <el-table
          v-if="isMobile"
          border
          :max-height="tableHeight"
          :data="users"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA' }"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
        >
          <!-- <el-table-column sortable type="selection" width="50">
      </el-table-column>-->

          <el-table-column label="操作" width="160">
            <template slot="header" slot-scope="{}">
              <span style="padding: 8px 0">
                操作
                <span class="caret-wrapper" style="width: 0px"></span>
              </span>
            </template>
            <template scope="scope">
              <el-link type="primary" @click="handledetails(scope.row)">
                <i class="el-icon-edit-outline"></i>
                审批
              </el-link>
            </template>
          </el-table-column>
          <!-- <el-table-column sortable prop="BWAcctNumber" label="ZCN ID" width="160"></el-table-column> -->
          <el-table-column sortable prop="Name" label="医院名称" min-width="220"></el-table-column>
          <el-table-column sortable prop="original_name" label="医院曾用名" min-width="220"></el-table-column>
          <!-- <el-table-column sortable prop="invoice_name" label="发票名称" width="220"></el-table-column> -->
          <el-table-column sortable prop="Address" label="医院地址" min-width="220"></el-table-column>
          <el-table-column sortable prop="province_name" label="省份" min-width=""></el-table-column>
          <!-- <el-table-column sortable prop="cityid" label="城市" width=""></el-table-column> -->
          <el-table-column prop="city_name" label="城市" min-width="100">
            <template slot="header" slot-scope="{}">
              <span style="padding: 0px 0; height: 34px; display: inline-block; line-height: 32px">
                城市
                <i @click="cp_zk_click" style="cursor: pointer" :class="HCO_LIST_IF ? 'el-icon-remove' : 'el-icon-circle-plus'"></i>
              </span>
              <!-- <span class="caret-wrapper" style="padding-top: 0px"></span> -->
            </template>
          </el-table-column>
          <!-- <div v-if="HCO_LIST_IF"> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="is_private" label="公私立" width="120">
            <template scope="scope">{{ scope.row.is_private ? '私立' : '公立' }}</template>
          </el-table-column> -->
          <el-table-column v-if="HCO_LIST_IF" sortable prop="sales_region_large_name" label="大区" width=""></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="sales_region_small_name" label="小区" width=""></el-table-column>
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="Category" label="类型" width=""></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="level" label="级别" width=""></el-table-column> -->
          <el-table-column v-if="HCO_LIST_IF" sortable prop="crystal_position_code" label="晶体销售岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="crystal_position_code_name" label="晶体销售" width="120"></el-table-column>
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="facility_position_code" label="CD临床应用发展岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="facility_position_code_name" label="设备销售" width="120"></el-table-column> -->
          <el-table-column v-if="HCO_LIST_IF" sortable prop="ref_crystal_position_code" label="REF销售岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="ref_crystal_position_code_name" label="REF销售" width="120"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="cat_crystal_position_code" label="飞白设备销售岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="cat_crystal_position_code_name" label="Cat销售" width="120"></el-table-column>
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="pd_position_code" label="PPD先进术式发展岗位号" width="150"></el-table-column>
          <el-table-column v-if="HCO_LIST_IF" sortable prop="pd_position_code_name" label="PPD销售" width="120"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="cat_Group" label="白内障私立医院集团" width="200"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="ref_Group" label="屈光飞白私立医院集团" width="200"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="IsContainsEyes" label="执业范围是否包含眼科相关" width="220"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="license_life" label="执业许可有效期" width="150"></el-table-column> -->
          <!-- <el-table-column v-if="HCO_LIST_IF" sortable prop="business_life" label="营业许可有效期" width="150"></el-table-column> -->
          <!-- </div> -->
        </el-table>
      </div>
      <!--工具条-->
      <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
          <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
          <el-pagination
            :background="true"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="50"
            :total="total"
            style="float: right"
          ></el-pagination>
        </el-col>
      </div>
    </div>
  </section>
</template>

<script>
import util from '@/../util/date'
import {
  HcoGetHcoinfoApprovalNO,
  store_data_ExportStore,
  GetHcoinfoApprovalNOExportExcel,
  store_data_Reback_Store,
  member_overrun_ExportExcel,
} from '@/api/api'
import { getButtonList } from '@/promissionRouter'
import Toolbar from '@/components/Toolbar'

export default {
  components: { Toolbar },
  data() {
    return {
      tableHeight: 0,
      HCO_LIST_IF: false,
      SalesOperation_if: false,
      edit_if_2: false,
      edit_if: true,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      users: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    cp_zk_click() {
      if (this.HCO_LIST_IF) {
        this.HCO_LIST_IF = false
      } else {
        this.HCO_LIST_IF = true
      }
    },
    ExportAccount() {
      // let para = this.filters
      var organization_id = localStorage.getItem('organization_id')
      let para = {
        organization_id: organization_id,
      }
      //  para.account_manager = para.account_manager.toString()
      //  window.open("​/api​/store_data​/ExportStore?")
      member_overrun_ExportExcel(para).then((res) => {
        //window.open("http://47.103.87.196:8082" + res.data.msg);
        window.location.href = res.data.msg
      })
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    // 导出
    // ExportAccount() {
    //   // let para = this.filters
    //   let para = {};
    //   //  para.account_manager = para.account_manager.toString()
    //   //  window.open("​/api​/store_data​/ExportStore?")
    //   store_data_ExportStore(para).then((res) => {
    //     //window.open("http://47.103.87.196:8082" + res.data.msg);
    //     window.location.href = res.data.msg;
    //   });
    // },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? '正常' : '未知'
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == '' ? '' : util.formatDate.format(new Date(row.CreateTime), 'yyyy-MM-dd')
    },
    handleCurrentChange(val) {
      this.page = val
      this.getModules()
    },
    ExportAccount() {
      let para = this.filters
      GetHcoinfoApprovalNOExportExcel(para).then((res) => {
        window.open('/api' + res.data.response)
      })
    },
    getModules_search() {
      this.page = 1
      this.getModules()
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.page = this.page
      console.log(para)
      // return
      //   let para = {
      //     page: this.page,
      //     key: this.filters.key
      //   };
      this.listLoading = true
      HcoGetHcoinfoApprovalNO(para).then((res) => {
        this.total = res.data.response.dataCount
        this.users = res.data.response.data
        this.listLoading = false
      })
    },
    //删除
    handleDel(ids) {
      console.log(ids)
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning',
      })
        .then(() => {
          this.listLoading = true
          //NProgress.start();
          let para = { id: ids }
          channel_Delete(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false
              return
            }
            this.listLoading = false
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: '删除成功',
                type: 'success',
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }

            this.getModules()
          })
        })
        .catch(() => {})
    },
    //编辑
    handleEdit: function (ids, progress, outletnumber__c) {
      // console.log(id)
      // return
      this.$router.push({
        path: '/StoreManage/add_store',
        query: {
          id: ids,
          type: 'store_bj',
          progress: progress,
          approval_type: 'store',
          outletnumber__c: outletnumber__c,
        },
      })
    },
    handleWithdraw(id) {
      // 撤回
      store_data_Reback_Store('store_id=' + id).then((res) => {
        if (res.data.success) {
          this.$message({
            message: '撤回成功',
            type: 'success',
          })
          this.getModules()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    handledetails: function (e) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: '/HCO/HCO_details',
        query: {
          id: e.ID,
          approval_data_id: e.approval_data_id,
          type: 'CK',
          status: 'SP',
          back_url: '/HCO/claim_release/no_approve',
          claim_release: 'claim_hco',
        },
      })
    },
    handleAdd: function (ids, progress) {
      this.$router.push({
        path: '/VipOverrun/vip_details',
        query: {
          id: ids,
          type: 'ADD',
          back_url: '/VipOverrun/Vip_list',
        },
      })
    },
    handledetails_SalesOperation: function (ids, progress, outletnumber__c) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: '/StoreManage/add_store',
        query: {
          id: ids,
          type: 'store_ck',
          progress: progress,
          approval_type: 'store',
          outletnumber__c: outletnumber__c,
          list_SalesOperation: 1,
        },
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    //localStorage 存储数组对象的方法
    saveObjArr(name, data) {
      localStorage.setItem(name, JSON.stringify(data))
    },

    //localStorage 获取数组对象的方法
    getObjArr(name) {
      return JSON.parse(window.localStorage.getItem(name))
    },
    details_tag(name) {
      var router_list = this.getObjArr('router')
      for (let i in router_list) {
        for (let s in router_list[i].children) {
          //  console.log(999)
          if (router_list[i].children[s].id == '175') {
            //  console.log(999)
            router_list[i].children[s].name = name
            router_list[i].children[s].meta.title = name
            console.log(router_list[i].children[s].name)
            this.saveObjArr('router', router_list)
            console.log(this.getObjArr('router'))
          }
        }
      }
      //  this.getObjArr('router') = router_list
      console.log(router_list)
    },
  },
  mounted() {
    this.isMobile = window.innerWidth <= 767
    console.log(this.isMobile)
    this.$nextTick(() => {
      this.$nextTick(() => {
        if (this.isMobile) {
          this.tableHeight = window.innerHeight - 380
        } else {
          this.tableHeight = window.innerHeight - 250
        }
      })
    })
    console.log(this.getObjArr('router'))
    this.getModules()
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
  },
}
</script>

<style scoped></style>
